import React from 'react'
import './contact.css'

const Contact = () => {
    return (
        <section className='contact section' id='contact'>
            <h2 className="section__title">Contactos</h2>
            <span className='section__subtitle'>-</span>

            <div className='contact__container container grid'>
                <div className='contact__content'>
                    <h3 className='contact__title'>Conversemos</h3>
                    <div className="contact__info">
                        <div className="contact__card">
                            <i className="bx bx-mail-send contact__card-icon"></i>

                            <h3 className='contact__card-title'>Email</h3>
                            <span className='contact__card-data'>developerkrafox@gmail.com</span>

                            <a href="mailto:developerkrafox@gmail.com" className="contact__button">
                                Contactar <i className="bx bx-right-arrow-alt contact__button-icon"></i>
                            </a>
                        </div>

                        {/* <div className="contact__card">
                            <i className="bx bxl-whatsapp contact__card-icon"></i>

                            <h3 className='contact__card-title'>Whatsapp</h3>
                            <span className='contact__card-data'>+593 123456789</span>

                            <a href="#" className="contact__button">
                                Contactar <i className="bx bx-right-arrow-alt contact__button-icon"></i>
                            </a>
                        </div> */}

                        <div className="contact__card">
                            <i className="bx bx-phone contact__card-icon"></i>

                            <h3 className='contact__card-title'>Call</h3>
                            <span className='contact__card-data'>+593 99 236 9438 </span>

                            <a href="tel:+593992369438" className="contact__button">
                                Contactar <i className="bx bx-right-arrow-alt contact__button-icon"></i>
                            </a>
                        </div>
                    </div>
                </div>

                <div className='contact__content'>
                    <h3 className='contact__title'>Tienes una idea</h3>
                    <form className='contact__form'>
                        <div className="contact__form-div">
                            <label className='contact__form-tag'>Nombre</label>
                            <input
                                type="text"
                                name='name'
                                className='contact__form-input'
                                placeholder='Ingrese su nombre'
                            />
                        </div>

                        <div className="contact__form-div">
                            <label className='contact__form-tag'>Mail</label>
                            <input
                                type="email"
                                name='email'
                                className='contact__form-input'
                                placeholder='Ingrese su email'
                            />
                        </div>

                        <div className="contact__form-div contact__form-area">
                            <label className='contact__form-tag'>Proyecto</label>
                            <textarea
                                name="project"
                                cols='30'
                                rows='10'
                                className='contact__form-input'
                                placeholder='Describa su proyecto'
                            ></textarea>
                        </div>
                        <button href="#contact" className='button button--flex'>
                            Enviar mensaje <i className="bx bxl-whatsapp whatsapp-icon"></i>
                        </button>
                    </form>
                </div>
            </div>

        </section>
    )
}

export default Contact
